import {CoinFlightEvents, CoinFlightModule, ReelConstants} from '@gongxigames/framework/slot';
import {GameLogic} from 'src/server/GameLogic';
import {WolfHavenSpin} from 'com/gongxigames/math/wolfhaven/engine/WolfHavenSpin';
import {GameCoinFlightView} from 'src/buyBonus/coinFlight/GameCoinFlightView';

export class GameCoinFlightModule extends CoinFlightModule {
    protected startCoinFlight(): void {
        const logic = this.logic as GameLogic;
        const spin = logic.spinData as WolfHavenSpin;
        const symbolIds = spin.symbolIds;
        const rubySymbolIndex = this._gameConfig.reelsConfig.rubySymbol!;
        const rowIndex = symbolIds[ReelConstants.REELS_AMOUNT - 1].indexOf(rubySymbolIndex);
        const view = this.view as GameCoinFlightView;

        view.startFlightAnimation(rowIndex, logic.getRubyBalance(), spin.getDimension()[ReelConstants.REELS_AMOUNT - 1]);
        view.playFlightSound();
        this.eventManager.emit(CoinFlightEvents.COIN_FLIGHT_STARTED, rowIndex);
    }
}
